var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.029 15.038c0 .64-.132 1.28-.377 1.865-.094.207-.188.395-.301.584-.886 1.507-2.506 2.43-4.239 2.43-2.713 0-4.917-2.204-4.917-4.917 0-2.713 2.204-4.917 4.917-4.917 1.319 0 2.524.528 3.429 1.394l-1.733 1.507 4.596.377.301-4.596-1.883 1.6c-1.206-1.224-2.864-1.977-4.71-1.977-3.654 0-6.612 2.976-6.612 6.612 0 3.655 2.976 6.612 6.612 6.612 2.336 0 4.521-1.243 5.708-3.259.15-.245.283-.508.396-.791.32-.754.49-1.564.508-2.392l-1.695-.132z",
    transform: "translate(-1419.000000, -132.000000) translate(1409.000000, 124.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.bed7345f62dd47d9715edd96d5438055.svg";
export { ForwardRef as ReactComponent };